// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var SiteLicenseType;
(function (SiteLicenseType) {
    SiteLicenseType[SiteLicenseType["UNKN"] = 0] = "UNKN";
    SiteLicenseType[SiteLicenseType["STTAXID"] = 1] = "STTAXID";
})(SiteLicenseType || (SiteLicenseType = {}));
//# sourceMappingURL=siteLicenseType.js.map